import { z } from 'zod';
/**
 * One step in an agentic task's pipeline (frontend spec §5.8).
 *
 * Steps render top-to-bottom in the task tray with a status icon and an
 * optional `detail` string (the agent's current observation/plan) plus an
 * optional `result` string (the artifact produced by the step).
 */
export const TaskStep = z.object({
    label: z.string(),
    status: z.enum(['pending', 'running', 'done', 'failed']),
    detail: z.string().optional(),
    result: z.string().optional(),
});
/**
 * A long-running agentic task surfaced in the bottom-right tray. Tasks are
 * Firestore-backed so they survive navigation and refresh; the client (or in
 * future, a Cloud Function) writes step transitions and the tray reads via
 * `onSnapshot`.
 *
 * `finalDeliverable` is the URL the analyst opens when the task completes —
 * for "Build full dossier" tasks this is `/entity/{entityName}`.
 */
export const AgenticTask = z.object({
    id: z.string(),
    orgId: z.string(),
    ownerUid: z.string(),
    title: z.string(),
    entityName: z.string().optional(),
    status: z.enum(['queued', 'running', 'done', 'failed']),
    steps: z.array(TaskStep).default([]),
    finalDeliverable: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
